import React from 'react';
import I18n from 'jsx!Component/I18n';
import DateTime from 'jsx!Component/DateTime';

const DictView = React.createClass({
  displayName: 'DictView',

  getInitialState: function () {
    return {
      oldkey:0
    };
  },

  getDefaultProps: function () {
    return {
      value: {}
    };
  },

  propTypes: {
    disabled: React.PropTypes.bool
  },

  getItem: function (label, values) {
    let value = values[label.name];
    if (value === undefined) {
      return null;
    }

    if (label.type === 'DateTime') {
      return <span><DateTime ts={parseInt(value)}/></span>;
    }
    if (label.type === 'TradeCmd') {
      return <span><I18n message={"tradeCmd." + value}/></span>;
    }

    return <span>{value}</span>;
  },

  render: function () {
    let items = [];

    let labels = [];

    if (this.props.labels) {
      labels = this.props.labels;
    } else {
      for (let key in this.props.value) {
        if (this.props.value.hasOwnProperty(key)) {
          labels.push({label: key, name: key});
        }
      }
    }

    for (let i = 0; i < labels.length;) {
      let tds = [];
      for (let col = 0; col < this.props.cols; col++) {
        if (i < labels.length) {
          let label = labels[i];
          let item = this.getItem(label, this.props.value);
          i++;

          if (item == null) {
            col--;
            continue;
          }

          // tds.push(<td><I18n message={label.label}/></td>);
          // tds.push(item);
        tds.push(<td key={`${col}-label`}><I18n message={label.label} /></td>);
        tds.push(<td key={`${col}-item`}>{item}</td>);
        } 
        else {
          break;
        }
      }
      if(this.state.oldkey!=i){    
        this.state.oldkey = i;    
      }
      items.push(<tr key={this.state.oldkey} >{tds}</tr>);

    }

    return (
      <table className="key_value">
        <tbody>
        {items}
        </tbody>
      </table>
    );
  }
});

export default DictView;



// WEBPACK FOOTER //
// ./src/js/Component/DictView.jsx